import { i18n } from 'locales/';
import en from './en.json';
import ru from './ru.json';

i18n.addResourceBundle('en', 'baccarat', en, true);
i18n.addResourceBundle('ru', 'baccarat', ru, true);
